import preparedReducer from './reducer';
import initialState from './states';
import { askRequest, resetAsk, setCategory, feedbackRequest } from './actions';

export { AskStatus, Category } from './types';

export const reducer = preparedReducer;

export const SLICE_NAME = 'askManual';

export const selectAskManual = (state) => state[SLICE_NAME] || initialState;

export const selectCategory = (state) => selectAskManual(state).category;
export const selectStatus = (state) => selectAskManual(state).status;
export const selectMessages = (state) => selectAskManual(state).messages;
export const selectError = (state) => selectAskManual(state).error;
export const selectFeedback = (state) => selectAskManual(state).feedback;

export const actions = {
  ask: askRequest,
  reset: resetAsk,
  setCategory,
  feedback: feedbackRequest,
};
